import React, { useEffect, useState } from "react";
import "../style/admin.css";
import Sidebar from "./partial/Sidebar";
import Header from "./partial/Header";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { FaIndianRupeeSign, FaPlus, FaTrash } from "react-icons/fa6";
import {
  useAllPackageQuery,
  useDeletePackageMutation,
} from "../../redux/API/PackageApi";
import DeleteModal from "./partial/DeleteModal";
import toast, { Toaster } from "react-hot-toast";
import ChangePassword from "./partial/ChangePassword";
import { ImgUrl, packageImgUrl } from "../Constant";

const AdminPackages = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeletId] = useState("");
  const [rows, setRows] = useState([]);
  const { data, refetch } = useAllPackageQuery();
  const [deleteData] = useDeletePackageMutation();
  const handleShow = (id) => {
    setDeletId(id);
    setShowModal(true);
  };

  console.log(packageImgUrl, "dssssssssssss");

  const handleToggle = () => {
    if (newClass === "") {
      setNewClass("main-active");
    } else {
      setNewClass("");
    }
    if (newSidebarClass === "") {
      setNewSidebarClass("closed");
    } else {
      setNewSidebarClass("");
    }
  };

  const handleDelete = async () => {
    try {
      await deleteData(deleteId).unwrap();
      setShowModal(false);
      refetch();
      toast.success("Package Deleted Successfully");
    } catch (error) {
      setShowModal(false);
      toast.error("Something went wrong, Please try later");
    }
  };

  useEffect(() => {
    if (data) {
      const updatedRows = [...data?.data]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map((i) => ({
          id: i?.user._id,
          photo: i.images && i.images.length > 0 ? i.images[0] : "",
          name: i.user.name,
          location: i.user.location,
          price: i.user.price,
          category: i.user.ptypeId,
          days: i.user.days,
          persons: i.user.persons,
          slug: i.user.slug
        }));
      setRows(updatedRows);
    }
    refetch();
  }, [data, refetch]);

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} setShowPass={setShowPass} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Packages
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/addpackages" className="btn btn-primary">
              Add Package <FaPlus />
            </Link>
          </div>
          <div className=" card p-4">
            <div className="table-wrapper w-100  overflow-x-auto ">
              <table className="table table-bordered admin_table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Image</th>
                    <th scope="col">Package Name</th>
                    <th scope="col">Package Type</th>
                    <th scope="col">Price</th>
                    <th scope="col">Location</th>
                    <th scope="col">Days</th>
                    <th scope="col">Persons</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <img
                          src={`${ImgUrl}${packageImgUrl}${row.photo}`}
                          alt={row.name}
                          width={100}
                        />
                      </td>
                      <td className="text-capitalize">{row.name}</td>
                      <td className="text-capitalize">{row?.category?.name}</td>
                      <td className="text-capitalize">
                        <FaIndianRupeeSign />
                        {row.price}
                      </td>
                      <td className="text-capitalize">{row.location}</td>
                      <td className="text-capitalize">{row.days}</td>
                      <td className="text-capitalize">{row.persons}</td>

                      <td>
                        <Link
                          to={`/admin/packages/${row?.slug}`}
                          className="fs-6 text-black"
                        >
                          <FaEdit />
                        </Link>
                        <Link
                          onClick={() => handleShow(row.id)}
                          className="text-danger ms-3 fs-6"
                        >
                          <FaTrash />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <div className="d-flex justify-content-between  align-items-center ">
              <p className="m-0">Showing 1 to 10 of 10 entries</p>
              <div aria-label="Page navigation example">
                <ul className="pagination">
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      Previous
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      1
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      2
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      3
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      Next
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {showModal && (
        <DeleteModal
          title={"Package"}
          handleDelete={handleDelete}
          setShowModal={setShowModal}
        />
      )}
      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default AdminPackages;
